"use client";
import React, { useState, useEffect } from 'react';
import { useSearchParams, useLocation } from 'react-router-dom';
import Header from '../Header';
import CategoryNav from '../CategoryNav';
import FilterSidebar from './FilterSidebar';
import ProductsMain from './ProductsMain';
import FooterSection from '../Footersection';

function Products() {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  
  const [filters, setFilters] = useState({
    categories: [],
    colors: [],
    fabrics: [],
    priceRange: [0, 200000]
  });

  const [sortBy, setSortBy] = useState('trending');
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [lastSearchParams, setLastSearchParams] = useState('');

  // Handle URL parameters and set initial filters
  useEffect(() => {
  const category = searchParams.get('category');
  const color = searchParams.get('color');
  const fabric = searchParams.get('fabric');

  setFilters({
    categories: category ? [category] : [],
    colors: color ? [color] : [],
    fabrics: fabric ? [fabric] : [],
    priceRange: [0, 200000],
  });
}, [location.search]);


  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleFiltersChange = (newFilters) => {
    setFilters(newFilters);
    // Reset to first page when filters change
    // This could be handled in ProductsMain component
  };

  const toggleFilter = () => {
    setIsFilterOpen(!isFilterOpen);
  };

  // Close filter sidebar when clicking outside on mobile
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) { // lg breakpoint
        setIsFilterOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      {/* <CategoryNav /> */}

      <main className="flex flex-col justify-center px-12 w-full max-md:px-5 max-md:max-w-full">
        <div className="flex flex-col justify-center items-start w-full max-md:max-w-full">
          <div className="flex flex-wrap gap-7 w-full relative">
            <FilterSidebar
              filters={filters}
              onFiltersChange={handleFiltersChange}
              isOpen={isFilterOpen}
              onToggle={toggleFilter}
            />
            <ProductsMain
              filters={filters}
              sortBy={sortBy}
              setSortBy={setSortBy}
            />
          </div>
        </div>
      </main>
      <FooterSection/>
    </div>
  );
}

export default Products;
